import React, { useState } from 'react'
import { Formik, Field, Form } from 'formik';
import axios from 'axios';
import { useHistory } from "react-router-dom";

const SigninForm = ({ product }) => {

    const history = useHistory();
    const [checked, setChecked] = useState(false);


    return (
        <Formik
            initialValues={{
                email: '',
                password: ''
            }}
            validate={values => {

                const errors = {};
                if (!values.email) {
                    errors.email = 'Email is Required';
                } else if (
                    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                ) {
                    errors.email = 'Invalid email address';
                }
                if (!values.password) {
                    errors.password = 'Password is Required';
                }

                return errors;

            }}
            onSubmit={async (values, { setSubmitting, setErrors }) => {
                setSubmitting(true);

                // const DASHBOARD_URL = 'https://app.evalexpert.io/insightsdashboard/pages/dashboard/'
                // const DASHBOARD_URL = 'http://dashboard/'
                // const DASHBOARD_URL = 'http://insights/'
                const DASHBOARD_URL = SERVER_URL+'/insightsdashboard/pages/dashboard/'
                let rememberme = checked ? 1 : '';
                const postData = { ...values, rememberme: rememberme };
                const res = await axios.post(SERVER_URL+'/insightsdashboard/pages/server/login.php?action=login', postData);
                const data = res.data;
                if (data.id) {
                    window.location.href = SERVER_URL+'/insightsdashboard/pages/dashboard/price-guide.php';
                } else {
                    setErrors({password: ' ', email: 'Incorrect credentials'})
                }

               
                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
                /* and other goodies */
            }) => (
                <form onSubmit={handleSubmit} className="space-y-4">
                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                            Email address
                        </label>
                        <div className="mt-1">
                            <input
                                id="email"
                                name="email"
                                type="email"
                                autoComplete="email"
                                placeholder="Email Address"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.email}
                                className={
                                    errors.email && touched.email ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                        : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                }
                            />
                            <p className="text-sm text-red-600" id="email-error">
                                {errors.email && touched.email && errors.email}
                            </p>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                            Password
                        </label>
                        <div className="mt-1">
                            <input
                                id="password"
                                name="password"
                                type="password"
                                autoComplete="password"
                                placeholder="Password"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.password}
                                className={
                                    errors.password && touched.password ? "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm focus:ring-red-500 focus:border-red-500 border-red-300 text-red-900 placeholder-red-300"
                                        : "appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                }
                            />
                            <p className="text-sm text-red-600" id="password-error">
                                {errors.password && touched.password && errors.password}
                            </p>
                        </div>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center">
                            <input
                                id="rememberme"
                                name="rememberme"
                                type="checkbox"
                                className="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-gray-300 rounded"
                                defaultChecked={checked}
                                onChange={() => setChecked(!checked)}
                            />
                            <label htmlFor="remember-me" className="ml-2 block text-sm text-gray-900">
                                Remember me
                            </label>
                        </div>
                        <div className="text-sm">
                            <a onClick={() => history.push('/insightsdashboard/pages/dashboard/forgot')} className="font-medium text-indigo-600 hover:text-indigo-500">
                                Forgot your password?
                            </a>
                        </div>
                    </div>

                    <div>
                        <button
                            type="submit"
                            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
                            disabled={isSubmitting}
                        >
                            Sign In
                        </button>
                    </div>
                    <p className="mt-2 text-sm text-gray-700">
                        Not an {product} User? <p className="cursor-pointer text-sm text-gray-800 inline font-medium" onClick={() => history.push('/insightsdashboard/pages/dashboard/signup')}>Sign Up</p>
                    </p>
                </form>
            )}
        </Formik>
    )
}

export default SigninForm
